import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const PageTopContext = React.createContext();

const PageTop = ({
  documentTitle,
  documentDescription,
  mainHeadingContent: receivedPageTitle,
  mainHeadingClasses = [],
  headingButton,
  renderHeadingContent
}) => {
  useEffect(() => {
    document.title = `WannaSport - ${documentTitle}`;
  }, [documentTitle]);

  mainHeadingClasses.push('page-title');

  const mainHeadingContent = !receivedPageTitle ? null : (
    <h1 className={mainHeadingClasses.join(' ')}>
      {receivedPageTitle}
    </h1>
  );

  const finalPageHeading = !headingButton ? mainHeadingContent : (
    <div className='buttoned-title-wrap'>
      {mainHeadingContent}
      {headingButton}
    </div>
  );

  return (
    <React.Fragment>
      {!renderHeadingContent ? finalPageHeading : (
        <PageTopContext.Provider value={{ finalPageHeading }}>
          <PageTopContext.Consumer>
            {renderHeadingContent}
          </PageTopContext.Consumer>
        </PageTopContext.Provider>
      )}
    </React.Fragment>
  );
};

PageTop.propTypes = {
  documentTitle: PropTypes.string.isRequired,
  documentDescription: PropTypes.string.isRequired,
  mainHeadingClasses: PropTypes.arrayOf(PropTypes.string),
  mainHeadingContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headingButton: PropTypes.element,
  renderHeadingContent: PropTypes.func
};

export default PageTop;
